import React, { useState, useEffect, useRef } from 'react';
import {
    Box,
    Grid,
    GridItem,
    VStack,
    Text,
    HStack,
    useDisclosure, useToast, Button, useBreakpointValue, Image, Icon,
} from '@chakra-ui/react';
import {useTranslation} from "react-i18next";

const DocumentGridGenerationEmpty = () => {
    const {t} = useTranslation();

    return (
        <VStack width={['95%','88%', '78%', '68%', '58%']}>
            <VStack spacing={4} width={'100%'} bg={'white'} mb={'10rem'}>
                <Text fontSize={18} fontWeight={'bold'}>{t("No workspaces yet")}</Text>
                <Text color={"gray.700"} textAlign={'center'}>{t("Create a new workspace to upload & chat with multiple files or reports simultaneously.")}</Text>
                <Text color={"gray.700"} textAlign={'center'}>{t("Get high-quality answers with in-text citations. Synthesize information from multiple files.")}</Text>
            </VStack>
        </VStack>
    );
};

export default DocumentGridGenerationEmpty;
